import { create } from 'zustand';
import { ApiUtils, CardApi, type CardEntity, RequestStrategyEnum } from '@shared/api';

interface UseCardsByAccountStore {
  loading: boolean;
  data: CardEntity[];
  error: string | null;
  getCardsByAccount: (accountId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useCardsByAccountStore = create<UseCardsByAccountStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getCardsByAccount: ApiUtils.wrapperApi(async (accountId, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await CardApi.getCardsByAccount(accountId, signal);
      set({ loading: false, data: result || [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
